import React from 'react';
import styles from './styles.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import services from '../../services';

const UsuarioCard = ({ usuario }) => {
  const history = useHistory();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Nome:</div>
      <div className={styles.info}>{usuario.nome}</div>
      <div className={styles.title}>Email:</div>
      <div className={styles.info}>{usuario.email}</div>
      <div className={styles.title}>CPF</div>
      <div className={styles.info}>{services.mask.cpf(usuario.cpf)}</div>
      <div className={styles.title}>Cargo</div>
      <div className={styles.info}>{usuario.cargo}</div>
      <div className={styles.title}>Perfil de acesso</div>
      <div className={styles.info}>
        {usuario.perfilAcesso == 'AcessaAdmin'
          ? 'Não Definido'
          : usuario.perfilAcesso}
      </div>
      <div className={styles.actionWrapper}>
        {usuario.status === 'Ativo' && (
          <div className={styles.andamento}>ATIVO</div>
        )}
        {usuario.status === 'Aguardando' && (
          <div className={styles.encerrado}>Aguardando Aprovação</div>
        )}
        {usuario.status === 'Inativo' && (
          <div className={styles.inativo}>INATIVO</div>
        )}

        <button
          className={styles.editar}
          onClick={() => {
            history.push(
              `/administradores/detalhes?usuario=${usuario.userId}&status=${usuario.status}`
            );
          }}
        >
          Editar
          <FontAwesomeIcon icon={faUpload} className={styles.icon} />
        </button>
      </div>
    </div>
  );
};

export default UsuarioCard;
